import { createContext } from 'react'
import type { Point } from './nestTarget'

/**
 * **Herausziehen aus der Checkliste** (#204, Etappe 3). Die Checkliste behält ihr eigenes
 * Ziehen und meldet nur, wenn eine Zeile ihren Rand verlässt. Die Liste um sie herum
 * (`TaskBoard`) zeigt dann die Einfügelinie oder ein Einhänge-Ziel und entscheidet beim
 * Loslassen.
 *
 * Zwei Listen teilen sich so kein `DndContext`. Außerhalb der Liste, etwa in den
 * Aufgaben-Details, fehlt der Kontext, und die Zeile bleibt in ihrer Checkliste.
 */
export interface SubtaskDragOut {
  /**
   * Der Zeiger ist außerhalb der Checkliste. `subtaskIds`: die gezogenen, in Checklisten-Reihenfolge.
   * `recurring`: Eine davon wiederholt sich — eine wiederkehrende Aufgabe ist dann kein Ziel (#205).
   */
  move(pointer: Point, subtaskIds: readonly string[], parentId: string, recurring?: boolean): void
  /** Zurück in der Checkliste: Linie und Ziel verschwinden. */
  back(): void
  /** Losgelassen draußen. `true`, wenn die Liste es übernommen hat. */
  drop(pointer: Point, subtaskIds: readonly string[], parentId: string): boolean
  cancel(): void
}

export const SubtaskDragOutContext = createContext<SubtaskDragOut | null>(null)

/**
 * **Ist die gezogene Unteraufgabe draußen?** Über der Aufgabenliste, aber nicht mehr über ihrer
 * Karte — oder unter der Liste (dann landet sie am Ende). Über leerer Fläche daneben oder
 * darüber bleibt es Umsortieren in der Checkliste.
 *
 * @param under was unter dem Zeiger liegt (ohne das Zugbild)
 */
export function isOutsideCard(pointer: Point, under: Element | undefined, card: Element, board: Element): boolean {
  if (!under || card.contains(under)) return false
  if (board.contains(under)) return true
  const list = board.getBoundingClientRect()
  return pointer.y > list.bottom && pointer.x >= list.left && pointer.x <= list.right
}
